<template>
  <div class="signup main-body middleOfParent">
    <div class="widthCenter35 middleOfParent">
      <div>
        <div v-if="!isSignUpSuccessful">
          <div class="text-center middleOfParent">
            <router-link to="/">
              <v-img
                src="../assets/auth/logo-crop.png"
                width="300"
                position="center"
                class="mt-10 mb-4"
                alt="logo"
              ></v-img>
            </router-link>
            <h4>{{ title }}</h4>
            <h2>Free Account</h2>
            <p>No Credit Card Required</p>
          </div>
          <div class="sign-up-form">
            <v-form ref="signUpForm">
              <v-row class="form-row ma-0">
                <v-col cols="12" sm="6" class="py-0 pl-0">
                  <v-text-field
                    v-model="firstName"
                    :rules="[rules.required]"
                    label="First Name"
                    outlined
                    dense
                    class="v-text-field"
                    required
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" class="pa-0">
                  <v-text-field
                    v-model="lastName"
                    :rules="[rules.required]"
                    label="Last Name"
                    outlined
                    dense
                    class="v-text-field"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <v-text-field
                    outlined
                    :rules="[rules.required]"
                    v-model="companyName"
                    label="Company Name"
                    dense
                    class="v-text-field"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="pa-0"
                  ><v-text-field
                    outlined
                    :rules="[rules.required, rules.email]"
                    v-model="email"
                    dense
                    label="E-mail Address"
                    class="v-text-field"
                    required
                  ></v-text-field
                ></v-col>
                <v-col cols="12" class="pa-0"
                  ><v-select
                    outlined
                    v-model="country"
                    :rules="[rules.required]"
                    :items="allEntCountries"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ offsetY: true }"
                    dense
                    label="Country"
                    required
                  ></v-select
                ></v-col>
                <v-col cols="12" class="pa-0"
                  ><v-text-field
                    outlined
                    :rules="[rules.required, rules.numberMax15]"
                    type="number"
                    v-model="phone"
                    dense
                    label="Phone Number"
                    class="v-text-field"
                    required
                  ></v-text-field
                ></v-col>
                <v-col cols="12" class="pa-0"
                  ><v-select
                    outlined
                    v-model="currency"
                    :rules="[rules.required]"
                    :items="allEntCurrencies"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ offsetY: true }"
                    dense
                    label="Currency"
                    class="v-text-field"
                    required
                  ></v-select
                ></v-col>
              </v-row>

              <v-btn
                height="50"
                :loading="loading"
                class="toDark mr-4 white--text"
                id="btn-signup"
                @click="submit"
              >
                <h2 class="text-capitalize">Get Started</h2>
              </v-btn>
            </v-form>
            <p>
              <strong
                >Already have an account?
                <router-link to="/" class="link">Sign In</router-link></strong
              >
            </p>
          </div>
        </div>
        <div
          v-else
          class="d-flex flex-column align-center fill-height fill-height"
        >
          <img
            src="../assets/auth/logo-crop.png"
            width="40%"
            class="my-10"
            alt="logo"
          />
          <h1 class="text-center widthCenter70">
            {{ resMessage }}
          </h1>
        </div>
      </div>
    </div>

    <!-- Snackbar Notification -->
    <v-snackbar
      class="snackbar"
      :color="snackBar.color"
      bottom
      right
      v-model="snackBar.active"
      :multi-line="snackBar.multiLine"
      :timeout="snackBar.timeout"
      >{{ snackBar.text }}</v-snackbar
    >
  </div>
</template>

<script>
import { mapState } from "vuex";
import all_countries from "../utils/countries.json";

export default {
  data() {
    return {
      title: "Get Started with GoDark",
      fullName: "",
      loading: false,
      firstName: "",
      lastName: "",
      companyName: "",
      email: "",
      phone: "",
      country: "",
      currency: "",
      tAndCcheckbox: "",
      countries: all_countries,
      entCountries: [],
      entCurrencies: [],
      filteredCountries: [],
      isSignUpSuccessful: false,
      resMessage: this.$store.state.signUpMessage,
      rules: {
        required: (value) => !!value || "Required",
        min8: (value) => value.length >= 8 || "Min 8 characters",
        number: (value) => !value || /^[0-9]*$/.test(value) || "Invalid value",
        numberMax15: (value) =>
          !value ||
          (/^[0-9]*$/.test(value) && value.length < 16) ||
          "Must by phone digit (Max. 15)",
        password: (value) => {
          const pattern = /^(?=\S*[a-z])(?=\S*[A-Z])(?=\S*\d)(?=\S*([^\w\s]|[_]))\S{8,}$/;
          return (
            pattern.test(value) ||
            "Min. 8 characters with at least one capital letter, a number and a special character."
          );
        },
        email: (value) =>
          !value ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) ||
          "Invalid E-mail",
      },
      snackBar: {
        active: false,
        text: "",
        color: "",
        multiLine: "",
        timeout: null,
      },
    };
  },
  methods: {
    submit() {
      if (this.$refs.signUpForm.validate()) {
        this.loading = true;
        this.$store.dispatch("processSignUp", {
          firstName: this.firstName,
          lastName: this.lastName,
          companyName: this.companyName,
          email: this.email,
          phone: this.phone,
          countryId: this.country,
          currencyId: this.currency,
        });
        // this.$router.push("/login");
      }
    },
  },
  watch: {
    signUpSuccessStatus(val) {
      if (val == true) {
        this.snackBar.active = true;
        this.snackBar.text = "Account Successfully created";
        this.snackBar.color = this.$store.state.snackBarSuccess;
        this.snackBar.timeout = this.$store.state.snackBarDuration;

        setTimeout(() => {
          this.isSignUpSuccessful = true;
          this.resMessage = this.$store.state.signUpMessage;
        }, this.$store.state.snackBarDuration);

        this.loading = false;
        this.disable = true;
      } else if (val == false) {
        this.snackBar.active = true;
        this.snackBar.text = "Oops! " + this.$store.state.signUpMessage;
        this.snackBar.color = this.$store.state.snackBarError;
        this.snackBar.multiLine = true;
        this.snackBar.timeout = this.$store.state.snackBarDuration;
        this.loading = false;
        this.$store.state.signUpSuccessStatus = "";
      }
    },
  },
  computed: {
    ...mapState(["signUpSuccessStatus", "allEntCountries", "allEntCurrencies"]),
  },
  created() {
    this.$store.dispatch("getAllCountries");
    this.$store.dispatch("getAllCurrencies");

    var data = this.countries;
    var newData = this.filteredCountries;
    data.forEach((item) => {
      newData.push(item.name);
    });
  },
};
</script>

<style scoped>
.main-body {
  height: 100%;
  width: 100%;
  background-color: #ffffff;
  font-family: "Montserrat";
}

#h4-first-col {
  margin-top: -16%;
  margin-left: 4%;
  font-style: bold;
  color: black;
  font-size: 26px;
  font-family: "Montserrat";
}

#h2-first-col {
  color: grey;
  margin-left: 4%;
  font-weight: normal;
  font-family: "Montserrat";
}

#col-1-img {
  margin-top: -10%;
}

#btn-signup {
  width: 100%;
}

.link {
  color: black;
  text-decoration: none;
  font-family: "Montserrat";
}

.v-messages__message {
  line-height: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
  padding-bottom: 10px;
}

@media only screen and (max-device-width: 480px) {
  .flex2 {
    display: none;
  }

  .main-body {
    width: 100%;
  }

  #h2-first-col {
    font-size: 18px;
  }

  h4 {
    font-size: 12px;
  }
}
</style>
